import { useEffect, useState } from 'react'
import { shopApi } from '~/src/shared/api/shopApi'
import { useCartStore } from '~/src/features/cart/stores/useCartStore'
import { useUiStore } from '~/src/shared/stores/useUiStore'

const INITIAL_FILTERS = {
  gender: '',
  min_price: '',
  max_price: '',
}

export function useCatalogController() {
  const [products, setProducts] = useState([])
  const [query, setQuery] = useState('')
  const [filters, setFilters] = useState(INITIAL_FILTERS)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const addItem = useCartStore((state) => state.addItem)
  const showNotice = useUiStore((state) => state.showNotice)

  useEffect(() => {
    let active = true

    async function loadProducts() {
      setLoading(true)

      try {
        const nextProducts = await shopApi.products({
          q: query,
          gender: filters.gender,
          min_price: filters.min_price,
          max_price: filters.max_price,
        })

        if (active) {
          setProducts(nextProducts)
          setError(null)
        }
      } catch (err) {
        if (active) {
          setError(err.message)
        }
      } finally {
        if (active) {
          setLoading(false)
        }
      }
    }

    loadProducts()

    return () => {
      active = false
    }
  }, [query, filters])

  async function handleAddToCart(product) {
    try {
      await addItem(product.id, 1)
      showNotice(`${product.name} se agregó al carrito`)
    } catch (err) {
      setError(err.message)
    }
  }

  function handleFilterChange(field, value) {
    setFilters((currentFilters) => ({
      ...currentFilters,
      [field]: value,
    }))
  }

  function clearFilters() {
    setQuery('')
    setFilters(INITIAL_FILTERS)
  }

  return {
    products,
    query,
    filters,
    error,
    loading,
    actions: {
      clearFilters,
      handleFilterChange,
      handleAddToCart,
      setQuery,
    },
  }
}
